import React, { useState } from "react";

// Convert a flag emoji (regional indicators) into an ISO2 code, e.g. 🇮🇹 -> "it"
function emojiToIso(emoji) {
  if (!emoji) return null;
  const cps = [...emoji].map((ch) => ch.codePointAt(0));
  const letters = cps
    .filter((cp) => cp >= 0x1f1e6 && cp <= 0x1f1ff)
    .map((cp) => String.fromCharCode(cp - 0x1f1e6 + 65));
  if (letters.length < 2) return null;
  return letters.join("").toLowerCase();
}

// Renders a crisp flag image; falls back to the emoji if the image can't load.
export function Flag({ emoji, className = "w-9 h-6" }) {
  const [failed, setFailed] = useState(false);
  const iso = emojiToIso(emoji);
  if (!iso || failed) {
    return <span className="text-3xl leading-none">{emoji || "🏳️"}</span>;
  }
  return (
    <img
      src={`https://flagcdn.com/w80/${iso}.png`}
      srcSet={`https://flagcdn.com/w160/${iso}.png 2x`}
      alt=""
      loading="lazy"
      onError={() => setFailed(true)}
      className={`${className} object-cover rounded-[3px] shadow-sm ring-1 ring-black/10`}
    />
  );
}
